// 게임 루트의 touch-action:none과 독립적으로 서랍 안쪽만 스크롤한다.
// 탭은 원래 버튼으로 보내고, 세로 8px 이상 끈 경우에만 스크롤로 전환한다.
import { toView } from '../shared/viewport';

export function installDrawerScroll(list: HTMLElement): void {
  let pointer = -1, y0 = 0, scroll0 = 0, dragged = false;
  list.addEventListener('pointerdown', (e) => {
    if (e.pointerType === 'mouse' || pointer !== -1) return;
    pointer = e.pointerId; y0 = toView(e.clientX, e.clientY).y; scroll0 = list.scrollTop; dragged = false;
  });
  list.addEventListener('pointermove', (e) => {
    if (e.pointerId !== pointer) return;
    // 폰 세로 모드에서는 #app이 90도 회전하므로 실제 clientY와 목록의 세로축이 다르다.
    const dy = toView(e.clientX, e.clientY).y - y0;
    if (!dragged && Math.abs(dy) < 8) return;
    if (!dragged) { dragged = true; list.setPointerCapture(pointer); }
    e.preventDefault(); e.stopPropagation();
    list.scrollTop = scroll0 - dy;
  });
  list.addEventListener('pointerup', (e) => { if (e.pointerId === pointer) pointer = -1; });
  list.addEventListener('pointercancel', (e) => { if (e.pointerId === pointer) { pointer = -1; dragged = false; } });
  // 드래그 끝의 합성 클릭이 배우기·배치 변경을 누르지 않도록 캡처 단계에서 소비한다.
  list.addEventListener('click', (e) => {
    if (!dragged) return;
    dragged = false; e.preventDefault(); e.stopImmediatePropagation();
  }, true);
}
